// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JevzyK9FC4XjiuBdmJV0{flex-direction:column;gap:40px;padding:37px 23px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `JevzyK9FC4XjiuBdmJV0`
};
export default ___CSS_LOADER_EXPORT___;
